import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { Group } from '../types/group';

export type UpdateGroupFields = Partial<Pick<Group, 'name' | 'description'> & { entities: string[] }>;

export type UpdateGroupsRequest = {
    id: string;
    fields: UpdateGroupFields;
}[];

async function updateGroups(request: UpdateGroupsRequest): Promise<void> {
    const { data } = await api.patch(`/groups`, request);
    return data;
}

export function useUpdateGroups(): UseMutationResult<void, AxiosError, UpdateGroupsRequest, unknown> {
    return useMutation(updateGroups, {
        onSettled: () => {
            queryClient.invalidateQueries(['groups']);
        },
    });
}
